"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
require("../../../../survey-app-external/src/modules/layout/styles/mobile.css");
var _react = _interopRequireDefault(require("react"));
var styles = function styles(theme) {
  return {
    progressBar: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      height: '1rem',
      borderRadius: '.5rem',
      overflow: 'hidden',
      flexGrow: 1,
      marginRight: '1rem',
      background: '#eaeaea'
    },
    progressBarWrapper: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '1rem'
    },
    colorPrimary: {
      backgroundColor: '#eaeaea'
    },
    barColorPrimary: {
      backgroundColor: '#4dc0e8'
    }
  };
};
var ProgressBarBase = function ProgressBarBase(_ref) {
  var value = _ref.value,
    classes = _ref.classes,
    style = _ref.style;
  var percent = value * 100;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.progressBarWrapper
  }, /*#__PURE__*/_react["default"].createElement(_material.LinearProgress, {
    value: Math.ceil(percent),
    variant: "determinate",
    className: (0, _classnames["default"])(classes.progressBar, "linearbar"),
    classes: {
      colorPrimary: classes.colorPrimary,
      barColorPrimary: classes.barColorPrimary
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: "progresspercent",
    variant: "subtitle1"
  }, Math.ceil(percent), " %"));
};
ProgressBarBase.propTypes = {
  value: _propTypes["default"].number.isRequired,
  classes: _propTypes["default"].object.isRequired,
  style: _propTypes["default"].object
};
var ProgressBar = exports.ProgressBar = (0, _styles.withStyles)(styles, {
  name: 'ProgressBar'
})(ProgressBarBase);